//@ts-expect-error Untyped module
import isMobile from 'isMobile';
export const getUserDeviceInfo = () => {
  return new isMobile.Class(navigator.userAgent);
};